/**
 * Main entry point — loaded on every page.
 * Initializes: Sentry, theme handlers, widgets.
 */

import { initSentry } from "./sentry";

// Initialize Sentry first (catches all subsequent errors)
initSentry();

// Phase 2: Theme modules
import "./theme";

// Phase 3: Widget modules
import "./widgets/tag-widget";
import "./widgets/nir-apps";
import "./widgets/modals";
import "./widgets/consumer-corner";
